module.exports = __webpack_public_path__ + "static/Ranger - How to Switch Report Versions-819e2479b14f6f428f991bb23017a5ca.pdf";